import styled from "@emotion/styled";
import { KmsTypeFilterItemFreeText } from "@kaltura/mediaspace-shared-types";
import { ChangeEvent, KeyboardEvent, useState } from "react";
import { BaseInput, Typography } from "@kaltura/ds-react-components";
import FormControl from "@mui/material/FormControl";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { FilterItemAdditionalProps } from "./FilterItemAdditionalProps";

export type FreeTextFilterItemProps = KmsTypeFilterItemFreeText & FilterItemAdditionalProps;

const StyledFreeTextFilterItem = styled(FormControl)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const StyledLabel = styled("label")(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
    marginBottom: theme.spacing(1),
    lineHeight: theme.spacing(2),
}));

/**
 * free text filter item - a single (controlled) free text filter item
 */
export function FreeTextFilterItem({ label, param, value = "", onChange, disabled = false }: FreeTextFilterItemProps) {
    const sendButtonAnalytics = useButtonAnalytics();

    const [innerValue, setInnerValue] = useState(value);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInnerValue(event.target.value);
    };

    /**
     * submit search on enter key
     */
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== "Enter") {
            return;
        }
        const value = (event.target as HTMLInputElement).value;
        // analytics
        const eventName = `Filters - ${param}`;
        sendButtonAnalytics(eventName, ButtonClickAnalyticsType.FILTER);
        // submit change
        onChange(param, value, true, false);
    };

    return (
        <StyledFreeTextFilterItem>
            <StyledLabel htmlFor={`input-${label}-${param}`}>
                <Typography variant={"formLabel"}>{label}</Typography>
            </StyledLabel>
            <BaseInput
                id={`input-${label}-${param}`}
                fullWidth={true}
                value={innerValue}
                disabled={disabled}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                inputProps={{
                    type: "search",
                }}
            />
        </StyledFreeTextFilterItem>
    );
}

export default FreeTextFilterItem;
